import { Typography, Link } from "@mui/material";
import { JSX } from "react";
import { Fragment } from "react/jsx-runtime";

interface TextBodyProps {
  children?: string | string[];
}

const urlRegex = /(https?:\/\/[^\s]+)/g;
function parseTextWithLinks(text: string): (string | JSX.Element)[] {
  const parts = text.split(urlRegex);

  return parts.map((part, index) => {
    if (urlRegex.test(part)) {
      return (
        <Link key={index} href={part} target="_blank" rel="noopener noreferrer">
          {part}
        </Link>
      );
    }
    return part;
  });
}

export default function TextBody(props: TextBodyProps) {
  if (!props.children) return null;

  const body = Array.isArray(props.children)
    ? props.children.join("")
    : props.children;

  const contentArray = parseTextWithLinks(body);

  return (
    <Typography
      whiteSpace="pre-wrap"
      sx={{
        overflowWrap: "break-word",
        wordBreak: "break-word",
        msWordBreak: "break-word",
      }}
      fontSize={"small"}
    >
      {contentArray}
    </Typography>
  );
}
